import { FC, RefObject, useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import BaseTemplate from '../BaseTemplate';
import { Label } from '../../atoms';
import UserManagementUsers from '../../organisms/UserManagemenetUsersOrganism';
import { Button, Container, Spinner } from 'react-bootstrap';
import { UserManagementUsersFilterOrganism } from '../../organisms';
import { UserDto } from '../../../store/contextAPI/user/dto/response/user.dto';
import { SortConfig, UserSearchFilters } from '../../../utils/types/types';
import { Role } from '../../../store/contextAPI/role/dto/response/role.dto';
import userServiceV3 from '../../../store/contextAPI/user/services/v3/user.service';
import { downloadDocument } from '../../../utils/Helpers/download-file-helper';
import styles from './UserManagementUsersTemplate.module.css';

export interface UserManagementUsersTemplateProps {
  data: UserDto[];
  roles: Role[];
  filters?: UserSearchFilters;
  handleDeleteUser: (id: string) => void;
  handleSearch: (filters: UserSearchFilters) => void;
  loadMoreRef?: RefObject<HTMLDivElement>;
  isFetchingNextPage?: boolean;
  sortConfig: SortConfig;
  setSortConfig: (value: SortConfig) => void;
}

const UserManagementUsersTemplate: FC<UserManagementUsersTemplateProps> = ({
  data,
  roles,
  filters,
  handleDeleteUser,
  handleSearch,
  loadMoreRef,
  isFetchingNextPage,
  sortConfig,
  setSortConfig,
}) => {
  const [isInactive, setIsInactive] = useState(false);

  const exportUsersData = async () => {
    const response = await userServiceV3.exportUsersData();
    downloadDocument(response);
  };

  const { mutate: handleExportUsersData, isPending: isPendingExportUsersData } =
    useMutation({
      mutationFn: exportUsersData,
      onError: (error) => console.log(error.message),
    });

  return (
    <BaseTemplate>
      <Container>
        <div className={styles.heading}>
          <Label content="Users" size="lg" />
          <Button
            variant="dark"
            style={isPendingExportUsersData ? { minWidth: '147px' } : undefined}
            onClick={() => handleExportUsersData()}
          >
            {isPendingExportUsersData ? (
              <Spinner size="sm" />
            ) : (
              'Export users data'
            )}
          </Button>
        </div>
        <UserManagementUsersFilterOrganism
          handleSearch={handleSearch}
          roles={roles}
          filters={filters}
          onSetIsInactive={(param) => setIsInactive(param)}
        />
        <div className={styles.tableWrapper}>
          <UserManagementUsers
            data={data}
            sortConfig={sortConfig}
            isInactive={isInactive}
            handleDeleteUser={handleDeleteUser}
            setSortConfig={setSortConfig}
          />
          <div ref={loadMoreRef} style={{ height: 1 }} />
          {isFetchingNextPage && (
            <p className={styles.tableLoaderText}>Loading more...</p>
          )}
        </div>
      </Container>
    </BaseTemplate>
  );
};

export default UserManagementUsersTemplate;
